import { AxiosInstance } from 'axios';
import { SonomamaAlbumSettingsRepository } from '~/model/repository/manager/parentSales/SonomamaAlbumSettingsRepository';

export default (Repository: AxiosInstance) => (): SonomamaAlbumSettingsRepository => ({
  get() {
    return Repository.get(`/memories-api/v1/admin/settings/sonomamaAlbum`);
  },
});
